// extracted by mini-css-extract-plugin
module.exports = {"firstChild":"components-HomeLinks-styles__firstChild","homeLinkContainerStyles":"components-HomeLinks-styles__homeLinkContainerStyles"};